import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  size?: "md" | "lg";
};
export function CtaButton({
  label,
  id,
  size = "lg"
}: CtaButtonProps) {
  const sizing = size === "lg" ? "px-6 py-5 text-[17px] sm:text-xl" : "px-5 py-4 text-[15px] sm:text-lg";
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full max-w-xl mx-auto items-center justify-center gap-3 rounded-2xl bg-cta ${sizing} text-center font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_#11833B] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-[#18b052] active:translate-y-[4px] active:shadow-[0_2px_0_#11833B] focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan/50`} data-id="element-319" data-mp="1m5o3db7nknse">
      <span data-id="element-320" data-mp="185n1bsfnjabc">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-321" data-mp="185wkox66yj82" />
    </a>;
}